/* eslint-disable no-unused-expressions */
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { notification, Checkbox, Button } from 'antd';
import WhatsappIntegrationActions from '@Actions/integrations/whatsappIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import termsLogo from '@Images/admin/integrations/T&C logo.png';

const WhatsappTnC = ({
  user, history, toggleWhatsappLoading, toggleWhatsapp,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);

  const toggleWhatsappIntegration = () => {
    setFormSubmitted(true);
    if (setIsAccepted) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        whatsapp_enabled: true,
        tandc_accepted: true,
      };
      toggleWhatsapp(payload, () => {
        history.push('/admin/integration/whatsapp/setup');
      });
    } else {
      notification.error({
        message: 'Please accept the terms and conditions to continue.',
        placement: 'top',
        duration: 4,
      });
    }
  };

  return (
    <Fragment>
      <div className="whatsapp-integration__tnc-wrapper">
        <div className="terms-and-conditions">
          <div className="icon">
            <img src={termsLogo} alt="T&C Icon" />
          </div>
          <div className="text">
            Please read and accept the terms and conditions in order to enable whatsapp notifications
          </div>
        </div>

        <div className="terms-list-container">
          <div className="introduction">
            These terms and conditions govern the use of WhatsApp communication within our platform. By accepting these terms, you agree to comply with our policies and guidelines for sending and receiving WhatsApp messages.
          </div>
          <ol className="terms-list">
            <li>
              <strong>Compliance with WhatsApp Business API Terms</strong>
              <p>Customer must ensure strict adherence to the terms and conditions of the WhatsApp Business API and all related policies in order to maintain compliance.</p>
            </li>

            <li>
              <strong>User Consent</strong>
              <p>In order to initiate communication through WhatsApp, customers are required to obtain explicit consent from users. Users should have the option to opt-in and provide their phone numbers for communication purposes.</p>
            </li>

            <li>
              <strong>Customer Consent</strong>
              <p>Customers should take the necessary steps to ensure that their users are fully informed and agree to receive messages via WhatsApp. It is important to integrate consent mechanisms into their platforms to facilitate this process effectively. Procuzy has an consent mechanism with which the recipient can opt-on or opt-out from receiving Whatsapp notifications.</p>
            </li>

            <li>
              <strong>Message Content</strong>
              <p>Customers need to adhere to the guidelines provided by WhatsApp regarding the content of messages. It is crucial to ensure that the messages are relevant to business transactions and comply with all WhatsApp policies.</p>
            </li>

            <li>
              <strong>Message Templates</strong>
              <p>When required by WhatsApp, customers must use approved message templates for specific types of communication. This ensures consistency and compliance with WhatsApp's guidelines.</p>
            </li>

            <li>
              <strong>Message Delivery and Timing</strong>
              <p>Customers should clearly communicate the timing of message delivery to users, avoiding excessive or spammy messaging. This helps to maintain a positive user experience and prevents any inconvenience.</p>
            </li>

            <li>
              <strong>User Rights</strong>
              <p>Customers must inform users about their rights, including the ability to opt-out, unsubscribe, or delete their accounts. It is important to provide mechanisms that allow users to exercise these rights easily.</p>
            </li>

            <li>
              <strong>Customer Support</strong>
              <p>Customers should establish customer support channels to address any issues or concerns that users may have regarding WhatsApp communication. This helps to enhance the overall user experience and satisfaction.</p>
            </li>

            <li>
              <strong>Legal and Regulatory Compliance:</strong>
              <p>Customers must comply with all local, national, and international laws and regulations governing electronic communication and data protection. It is essential to ensure that all activities are conducted within the legal framework.</p>
            </li>

            <li>
              <strong>WhatsApp Business Account:</strong>
              <p>Clients shall register their businesses on WhatsApp and obtain WhatsApp Business Accounts if required.</p>
            </li>

            <li>
              <strong>API Usage Limits</strong>
              <p>Customers need to be aware of the usage limits and pricing structures set by Procuzy for Whatsapp communication. It is important to ensure that these limits are not exceeded to avoid any disruptions or additional costs.</p>
            </li>
            <li>
              <strong>Termination Clause</strong>
              <p>Customers should acknowledge that WhatsApp communication may be terminated under specific circumstances as outlined in the policies. It is important to be aware of these conditions to ensure compliance and avoid any disruptions.</p>
            </li>
          </ol>
        </div>

        <div className="custom-checkbox-container">
          <Checkbox
            checked={isAccepted}
            disabled={toggleWhatsappLoading}
            onChange={() => setIsAccepted(!isAccepted)}
          />
          <span className="custom-checkbox-label">I agree to the terms and conditions</span>
        </div>

        <div className="whatsapp__buttons-container">
          <H3Button
            text="Accept"
            onClick={() => {
              if (isAccepted) {
                toggleWhatsappIntegration();
              } else {
                notification.error({
                  message: 'Please accept the Terms & Conditions to proceed.',
                  placement: 'top',
                  duration: 4,
                });
              }
            }}
            customClass="whatsapp__location-submit accept-button"
            isLoading={toggleWhatsappLoading}
            disabled={toggleWhatsappLoading}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, WhatsappIntegrationReducers }) => ({
  user: UserReducers.user,
  toggleWhatsappLoading: WhatsappIntegrationReducers.toggleWhatsappLoading,
});

const mapDispatchToProps = (dispatch) => ({
  toggleWhatsapp: (payload, callback) => dispatch(WhatsappIntegrationActions.toggleWhatsapp(payload, callback)),
});

WhatsappTnC.propTypes = {
  user: PropTypes.any,
  toggleWhatsappLoading: PropTypes.bool,
  history: PropTypes.func,
  toggleWhatsapp: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WhatsappTnC));
